<header class="flex header">
  @if (type && type.id) {
    <h2>{{ 'Modal_Type_Process.Edit' | translate }}</h2>
  } @else {
    <h2>{{ 'Modal_Type_Process.Add' | translate }}</h2>
  }
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <div class="flex gap-[1rem]">
    <p-button [label]="'Modal_Type_Process.OpenAll' | translate" variant="outlined" (click)="openAll()" />
    <p-button [label]="'Modal_Type_Process.CloseAll' | translate" variant="outlined" (click)="closeAll()" />
  </div>

  <div *ngIf="assetProcesses.value.length === 0" class="empty-message">
    <p>
      {{ 'Modal_Type_Process.NoProcessesAdded' | translate }}
    </p>
  </div>

  <ul *ngFor="let process of assetProcesses.value; let i = index" class="process-list">
    <li>
      <div class="process-header">
        <p-button variant="outlined" (click)="toggleSubProcess(process.id)">
          <span class="material-icons toggle-arrow">
            {{ showProcessesDict[process.id] ? 'expand_less' : 'expand_more' }}
          </span>
        </p-button>

        <input
          class="w-full p-inputtext p-component p-filled"
          type="text"
          [value]="process.name"
          (change)="updateProcessName(i, getInputValue($event))"
          [placeholder]="'Modal_Type_Process.ProcessName' | translate"
        />

        <p-button icon="pi pi-times" variant="outlined" (click)="deleteProcess(i)" />
      </div>

      <div *ngIf="showProcessesDict[process.id]" class="subprocess-container">
        <ul class="subprocess-list">
          <li *ngFor="let subProcess of process.subProcesses; let j = index">
            <div class="subprocess-header">
              <p-button variant="outlined" (click)="toggleSubSubProcess(subProcess.id)">
                <span class="material-icons toggle-arrow">
                  {{ showSubProcessesDict[subProcess.id] ? 'expand_less' : 'expand_more' }}
                </span>
              </p-button>

              <input
                class="w-full p-inputtext p-component p-filled"
                type="text"
                [value]="subProcess.name"
                (change)="updateSubProcessName(i, j, getInputValue($event))"
                [placeholder]="'Modal_Type_Process.SubProcessName' | translate"
              />
              <p-button icon="pi pi-times" (click)="deleteSubProcess(i, j)" />
            </div>

            <div *ngIf="showSubProcessesDict[subProcess.id]" class="nested-subprocess-container">
              <ul class="nested-subprocess-list">
                <li *ngFor="let nestedSubProcess of subProcess.subProcesses; let k = index">
                  <div class="nested-subprocess-header">
                    <input
                      class="w-full p-inputtext p-component p-filled"
                      type="text"
                      [value]="nestedSubProcess.name"
                      (change)="updateNestedSubProcessName(i, j, k, getInputValue($event))"
                      [placeholder]="'Modal_Type_Process.NestedSubProcessName' | translate"
                    />

                    <p-button label="Add" icon="pi pi-times" (click)="deleteNestedSubProcess(i, j, k)" />
                  </div>
                </li>
                <li class="add-nested-subprocess">
                  <p-button [label]="'Modal_Type_Process.AddGrandChildProcess' | translate" variant="outlined" (click)="addNestedSubProcess(i, j)" />
                </li>
              </ul>
            </div>
          </li>
          <li class="add-subprocess">
            <button class="mainAction" (click)="addSubProcess(i)">Add Child Process</button>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <p-button class="w-full" [label]="'Modal_Type_Process.Add' | translate" (click)="addProcess()" />
</section>

<footer>
  <p-button class="w-full" (click)="onSave()" [disabled]="formTypeGroup.invalid" [label]="'Save' | translate" />
  <p-button class="w-full" variant="outlined" (click)="onClose()" [label]="'Cancel' | translate" />
</footer>
